﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcChartAnnotation from '@mescius/wijmo.chart.annotation';
var WjFlexChartAnnotationLayerBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnnotationLayerBehavior, _super);
    function WjFlexChartAnnotationLayerBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnnotationLayerBehavior.tag = 'wj-flex-chart-annotation-layer';
    WjFlexChartAnnotationLayerBehavior.parentInCtor = true;
    WjFlexChartAnnotationLayerBehavior.props = [];
    WjFlexChartAnnotationLayerBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnnotationLayerBehavior.classCtor = function () { return wjcChartAnnotation.AnnotationLayer; };
    return WjFlexChartAnnotationLayerBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.annotation.AnnotationLayer} class.
 *
 * The <b>wj-flex-chart-annotation-layer</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 *  or {@link wijmo.vue2.chart.finance.WjFinancialChart}.
 *
 * The <b>wj-flex-chart-annotation-layer</b> component may contain
 * the following child components:
 * {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationText}
 * , {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationEllipse}
 * , {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationRectangle}
 * , {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationLine}
 * , {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationPolygon}
 * , {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationCircle}
 * , {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationSquare}
 * and {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationImage}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.annotation.AnnotationLayer} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnnotationLayer = WjFlexChartAnnotationLayerBehavior.register();
function registerV3WjFlexChartAnnotationLayer(app) {
    app.component(WjFlexChartAnnotationLayerBehavior.tag, WjFlexChartAnnotationLayer);
}
var WjFlexChartAnnotationTextBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnnotationTextBehavior, _super);
    function WjFlexChartAnnotationTextBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnnotationTextBehavior.tag = 'wj-flex-chart-annotation-text';
    WjFlexChartAnnotationTextBehavior.parentProp = 'items';
    WjFlexChartAnnotationTextBehavior.siblingId = 'annotation';
    WjFlexChartAnnotationTextBehavior.props = [
        'wjProperty',
        'type',
        'attachment',
        'position',
        'point',
        'seriesIndex',
        'pointIndex',
        'offset',
        'isVisible',
        'tooltip',
        'text',
        'content',
        'name',
        'width',
        'height',
        'start',
        'end',
        'radius',
        'length',
        'href'
    ];
    WjFlexChartAnnotationTextBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnnotationTextBehavior.classCtor = function () { return wjcChartAnnotation.Text; };
    return WjFlexChartAnnotationTextBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.annotation.Text} class.
 *
 * The <b>wj-flex-chart-annotation-text</b> component should be contained in
 * a {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationLayer} component.
 *
 * The <b>wj-flex-chart-annotation-text</b> component may contain
 * a {@link wijmo.vue2.chart.WjFlexChartDataPoint} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.annotation.Text} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnnotationText = WjFlexChartAnnotationTextBehavior.register();
function registerV3WjFlexChartAnnotationText(app) {
    app.component(WjFlexChartAnnotationTextBehavior.tag, WjFlexChartAnnotationText);
}
var WjFlexChartAnnotationEllipseBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnnotationEllipseBehavior, _super);
    function WjFlexChartAnnotationEllipseBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnnotationEllipseBehavior.tag = 'wj-flex-chart-annotation-ellipse';
    WjFlexChartAnnotationEllipseBehavior.parentProp = 'items';
    WjFlexChartAnnotationEllipseBehavior.siblingId = 'annotation';
    WjFlexChartAnnotationEllipseBehavior.props = [
        'wjProperty',
        'type',
        'attachment',
        'position',
        'point',
        'seriesIndex',
        'pointIndex',
        'offset',
        'isVisible',
        'tooltip',
        'text',
        'content',
        'name',
        'width',
        'height',
        'start',
        'end',
        'radius',
        'length',
        'href'
    ];
    WjFlexChartAnnotationEllipseBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnnotationEllipseBehavior.classCtor = function () { return wjcChartAnnotation.Ellipse; };
    return WjFlexChartAnnotationEllipseBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.annotation.Ellipse} class.
 *
 * The <b>wj-flex-chart-annotation-ellipse</b> component should be contained in
 * a {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationLayer} component.
 *
 * The <b>wj-flex-chart-annotation-ellipse</b> component may contain
 * a {@link wijmo.vue2.chart.WjFlexChartDataPoint} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.annotation.Ellipse} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnnotationEllipse = WjFlexChartAnnotationEllipseBehavior.register();
function registerV3WjFlexChartAnnotationEllipse(app) {
    app.component(WjFlexChartAnnotationEllipseBehavior.tag, WjFlexChartAnnotationEllipse);
}
var WjFlexChartAnnotationRectangleBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnnotationRectangleBehavior, _super);
    function WjFlexChartAnnotationRectangleBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnnotationRectangleBehavior.tag = 'wj-flex-chart-annotation-rectangle';
    WjFlexChartAnnotationRectangleBehavior.parentProp = 'items';
    WjFlexChartAnnotationRectangleBehavior.siblingId = 'annotation';
    WjFlexChartAnnotationRectangleBehavior.props = [
        'wjProperty',
        'type',
        'attachment',
        'position',
        'point',
        'seriesIndex',
        'pointIndex',
        'offset',
        'isVisible',
        'tooltip',
        'text',
        'content',
        'name',
        'width',
        'height',
        'start',
        'end',
        'radius',
        'length',
        'href'
    ];
    WjFlexChartAnnotationRectangleBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnnotationRectangleBehavior.classCtor = function () { return wjcChartAnnotation.Rectangle; };
    return WjFlexChartAnnotationRectangleBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.annotation.Rectangle} class.
 *
 * The <b>wj-flex-chart-annotation-rectangle</b> component should be contained in
 * a {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationLayer} component.
 *
 * The <b>wj-flex-chart-annotation-rectangle</b> component may contain
 * a {@link wijmo.vue2.chart.WjFlexChartDataPoint} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.annotation.Rectangle} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnnotationRectangle = WjFlexChartAnnotationRectangleBehavior.register();
function registerV3WjFlexChartAnnotationRectangle(app) {
    app.component(WjFlexChartAnnotationRectangleBehavior.tag, WjFlexChartAnnotationRectangle);
}
var WjFlexChartAnnotationLineBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnnotationLineBehavior, _super);
    function WjFlexChartAnnotationLineBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnnotationLineBehavior.tag = 'wj-flex-chart-annotation-line';
    WjFlexChartAnnotationLineBehavior.parentProp = 'items';
    WjFlexChartAnnotationLineBehavior.siblingId = 'annotation';
    WjFlexChartAnnotationLineBehavior.props = [
        'wjProperty',
        'type',
        'attachment',
        'position',
        'point',
        'seriesIndex',
        'pointIndex',
        'offset',
        'isVisible',
        'tooltip',
        'text',
        'content',
        'name',
        'width',
        'height',
        'start',
        'end',
        'radius',
        'length',
        'href'
    ];
    WjFlexChartAnnotationLineBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnnotationLineBehavior.classCtor = function () { return wjcChartAnnotation.Line; };
    return WjFlexChartAnnotationLineBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.annotation.Line} class.
 *
 * The <b>wj-flex-chart-annotation-line</b> component should be contained in
 * a {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationLayer} component.
 *
 * The <b>wj-flex-chart-annotation-line</b> component may contain
 * a {@link wijmo.vue2.chart.WjFlexChartDataPoint} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.annotation.Line} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnnotationLine = WjFlexChartAnnotationLineBehavior.register();
function registerV3WjFlexChartAnnotationLine(app) {
    app.component(WjFlexChartAnnotationLineBehavior.tag, WjFlexChartAnnotationLine);
}
var WjFlexChartAnnotationPolygonBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnnotationPolygonBehavior, _super);
    function WjFlexChartAnnotationPolygonBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnnotationPolygonBehavior.tag = 'wj-flex-chart-annotation-polygon';
    WjFlexChartAnnotationPolygonBehavior.parentProp = 'items';
    WjFlexChartAnnotationPolygonBehavior.siblingId = 'annotation';
    WjFlexChartAnnotationPolygonBehavior.props = [
        'wjProperty',
        'type',
        'attachment',
        'position',
        'point',
        'seriesIndex',
        'pointIndex',
        'offset',
        'isVisible',
        'tooltip',
        'text',
        'content',
        'name',
        'width',
        'height',
        'start',
        'end',
        'radius',
        'length',
        'href'
    ];
    WjFlexChartAnnotationPolygonBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnnotationPolygonBehavior.classCtor = function () { return wjcChartAnnotation.Polygon; };
    return WjFlexChartAnnotationPolygonBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.annotation.Polygon} class.
 *
 * The <b>wj-flex-chart-annotation-polygon</b> component should be contained in
 * a {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationLayer} component.
 *
 * The <b>wj-flex-chart-annotation-polygon</b> component may contain
 * a {@link wijmo.vue2.chart.WjFlexChartDataPoint} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.annotation.Polygon} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnnotationPolygon = WjFlexChartAnnotationPolygonBehavior.register();
function registerV3WjFlexChartAnnotationPolygon(app) {
    app.component(WjFlexChartAnnotationPolygonBehavior.tag, WjFlexChartAnnotationPolygon);
}
var WjFlexChartAnnotationCircleBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnnotationCircleBehavior, _super);
    function WjFlexChartAnnotationCircleBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnnotationCircleBehavior.tag = 'wj-flex-chart-annotation-circle';
    WjFlexChartAnnotationCircleBehavior.parentProp = 'items';
    WjFlexChartAnnotationCircleBehavior.siblingId = 'annotation';
    WjFlexChartAnnotationCircleBehavior.props = [
        'wjProperty',
        'type',
        'attachment',
        'position',
        'point',
        'seriesIndex',
        'pointIndex',
        'offset',
        'isVisible',
        'tooltip',
        'text',
        'content',
        'name',
        'width',
        'height',
        'start',
        'end',
        'radius',
        'length',
        'href'
    ];
    WjFlexChartAnnotationCircleBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnnotationCircleBehavior.classCtor = function () { return wjcChartAnnotation.Circle; };
    return WjFlexChartAnnotationCircleBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.annotation.Circle} class.
 *
 * The <b>wj-flex-chart-annotation-circle</b> component should be contained in
 * a {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationLayer} component.
 *
 * The <b>wj-flex-chart-annotation-circle</b> component may contain
 * a {@link wijmo.vue2.chart.WjFlexChartDataPoint} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.annotation.Circle} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnnotationCircle = WjFlexChartAnnotationCircleBehavior.register();
function registerV3WjFlexChartAnnotationCircle(app) {
    app.component(WjFlexChartAnnotationCircleBehavior.tag, WjFlexChartAnnotationCircle);
}
var WjFlexChartAnnotationSquareBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnnotationSquareBehavior, _super);
    function WjFlexChartAnnotationSquareBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnnotationSquareBehavior.tag = 'wj-flex-chart-annotation-square';
    WjFlexChartAnnotationSquareBehavior.parentProp = 'items';
    WjFlexChartAnnotationSquareBehavior.siblingId = 'annotation';
    WjFlexChartAnnotationSquareBehavior.props = [
        'wjProperty',
        'type',
        'attachment',
        'position',
        'point',
        'seriesIndex',
        'pointIndex',
        'offset',
        'isVisible',
        'tooltip',
        'text',
        'content',
        'name',
        'width',
        'height',
        'start',
        'end',
        'radius',
        'length',
        'href'
    ];
    WjFlexChartAnnotationSquareBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnnotationSquareBehavior.classCtor = function () { return wjcChartAnnotation.Square; };
    return WjFlexChartAnnotationSquareBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.annotation.Square} class.
 *
 * The <b>wj-flex-chart-annotation-square</b> component should be contained in
 * a {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationLayer} component.
 *
 * The <b>wj-flex-chart-annotation-square</b> component may contain
 * a {@link wijmo.vue2.chart.WjFlexChartDataPoint} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.annotation.Square} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnnotationSquare = WjFlexChartAnnotationSquareBehavior.register();
function registerV3WjFlexChartAnnotationSquare(app) {
    app.component(WjFlexChartAnnotationSquareBehavior.tag, WjFlexChartAnnotationSquare);
}
var WjFlexChartAnnotationImageBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnnotationImageBehavior, _super);
    function WjFlexChartAnnotationImageBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnnotationImageBehavior.tag = 'wj-flex-chart-annotation-image';
    WjFlexChartAnnotationImageBehavior.parentProp = 'items';
    WjFlexChartAnnotationImageBehavior.siblingId = 'annotation';
    WjFlexChartAnnotationImageBehavior.props = [
        'wjProperty',
        'type',
        'attachment',
        'position',
        'point',
        'seriesIndex',
        'pointIndex',
        'offset',
        'isVisible',
        'tooltip',
        'text',
        'content',
        'name',
        'width',
        'height',
        'start',
        'end',
        'radius',
        'length',
        'href'
    ];
    WjFlexChartAnnotationImageBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnnotationImageBehavior.classCtor = function () { return wjcChartAnnotation.Image; };
    return WjFlexChartAnnotationImageBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.annotation.Image} class.
 *
 * The <b>wj-flex-chart-annotation-image</b> component should be contained in
 * a {@link wijmo.vue2.chart.annotation.WjFlexChartAnnotationLayer} component.
 *
 * The <b>wj-flex-chart-annotation-image</b> component may contain
 * a {@link wijmo.vue2.chart.WjFlexChartDataPoint} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.annotation.Image} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnnotationImage = WjFlexChartAnnotationImageBehavior.register();
function registerV3WjFlexChartAnnotationImage(app) {
    app.component(WjFlexChartAnnotationImageBehavior.tag, WjFlexChartAnnotationImage);
}
export function registerChartAnnotation(app) {
    if (VueApi.isV3Plus) {
        registerV3WjFlexChartAnnotationLayer(app);
        registerV3WjFlexChartAnnotationText(app);
        registerV3WjFlexChartAnnotationEllipse(app);
        registerV3WjFlexChartAnnotationRectangle(app);
        registerV3WjFlexChartAnnotationLine(app);
        registerV3WjFlexChartAnnotationPolygon(app);
        registerV3WjFlexChartAnnotationCircle(app);
        registerV3WjFlexChartAnnotationSquare(app);
        registerV3WjFlexChartAnnotationImage(app);
    }
}
